import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';
import React from 'react';
import TextArea from '../components/forms/TextArea';

class InstallationServiceComments extends React.Component {
  render() {
    const {
      translate,
      installationComment,
      onCommentChanged,
    } = this.props;

    return (
      <div>
        <Table className="table-width" bordered>
          <thead className="table-head">
            <tr>
              <th>{translate('service_installation.installation_title')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <h3 className="table-body-text-padding">
                  {translate('service_installation.installation_description')}
                </h3>
                <div className="row">
                  <div className="col-sm-8 col-md-offset-2">
                    <TextArea
                    name="installationComments"
                    value={installationComment}
                    onChange={onCommentChanged}
                    rows={3} />
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = (state = {}) => {
  const locale = state.locale || {};
  const activeLanguage = getActiveLanguage(locale);
  return {
    currentLanguage: activeLanguage?.code || 'fi',
    translate: getTranslate(locale),
    session: state.session.session || {},
  };
};

export default connect(
  mapStateToProps,
  null,
)(InstallationServiceComments);
